import React from "react";

import StyledAppFooter from "../../styles/_Footer.styles";

const AppFooter = () => {
  return (
    <>
      <StyledAppFooter className="app-footer">
        <p>© 2022 Nasdaq Information Services, LLC. All Rights Reserved.</p>
      </StyledAppFooter>
    </>
  );
};

export default AppFooter;
